import { createSelector } from '@reduxjs/toolkit';

const getState = (state) => state.adminExport;

export const adminExportDataSelector = createSelector(getState, (state) => state.adminExportData);
export const adminExportMetaDataSelector = createSelector(
  getState,
  (state) => state.adminExportMetaData,
);
export const isLoadingAdminExportSelector = createSelector(
  getState,
  (state) => state.isLoadingAdminExport,
);

export const isLoadingDownloadAdminExport = createSelector(
  getState,
  (state) => state.isLoadingDownloadAdminExport,
);
